import React from 'react'
import styles from './FinalistCard.scss'
import {photoLarge} from 'lib/urlHelpers'
import {Icon} from 'common/LegacyIcon'

// hacky because one-off
const isBlockWithImage = (block) => block.type === 'atomic' && block.data && block.data.type === 'gallery' && block.data.imageIds && block.data.imageIds[0]
export const coverImage = (reportContent) => {
  const firstBlockWithImage = reportContent.blocks.find(isBlockWithImage)
  if (!firstBlockWithImage) { return null }
  return firstBlockWithImage.data.imageIds[0]
}

export const FinalistCard = ({report, onChangeRoute, voted}) => (
  <div onClick={() => onChangeRoute(report.id)} className={styles.FinalistCard} style={{backgroundImage: `url(${photoLarge(coverImage(report.reportContent))})`}}>
    {voted && <div className={styles.votedBadge}><Icon i='star' size={18} /><span>Voted Report</span></div>}
    <div className={styles.content}>
      <h2 className={styles.title} onClick={() => onChangeRoute(report.id)}>{report.title}</h2>
      <div className={styles.authorship}>by {report.user.name}</div>
      <a className={styles.readLink}><span>Read to Vote</span> <Icon i='rightChevron' size={10} /></a>
    </div>
  </div>
)

export const FinalistCardContainer = (props) => <div className={styles.container} {...props} />
